/**
 * Leitura de uma participacao em campanha para a tela.
 *
 * A participacao vem com a campanha aninhada e com o override de comissao proprio, entao
 * quase todo campo tem duas origens possiveis. Concentrar isso aqui evita que cada
 * componente reinvente a precedencia.
 */
import { currencyFormatter } from '@/util/Util'

export function campaign(participation) {
  return (participation && participation.campaign) || {}
}

export function campaignName(participation) {
  return campaign(participation).name || ''
}

/** "Estabelecimento · Modalidade" — a segunda linha do cabecalho de cada campanha. */
export function entityLine(participation) {
  const c = campaign(participation)
  const entity = (c.legal_entity && c.legal_entity.name)
    || (c.legalEntity && c.legalEntity.name)
    || ''
  const modality = c.modality_name || (c.modality && c.modality.name) || ''

  return [entity, modality].filter(Boolean).join(' · ')
}

/**
 * Comissao efetiva do influencer nesta campanha.
 *
 * `PE` e percentual e `VA` e valor fixo em reais. O override da participacao vence o da
 * campanha — e a mesma precedencia de `Campaign::commissionCentsFor()`. O bonus de nivel
 * nao entra aqui de proposito: ele so se aplica ao tipo percentual, e somar na etiqueta
 * daria um numero que nao bate com o contrato exibido na campanha.
 */
export function commissionLabel(participation) {
  const c = campaign(participation)
  const hasOverride = participation && participation.commission_override_type

  const type = hasOverride ? participation.commission_override_type : c.commission_type
  const amount = hasOverride ? participation.commission_override_amount : c.commission_amount

  if (amount === null || amount === undefined) return '—'

  return type === 'VA'
    ? currencyFormatter(Number(amount))
    : `${Number(amount).toLocaleString('pt-BR', { maximumFractionDigits: 2 })}%`
}

/** Metricas agregadas. Zero enquanto o backend nao enriquecer a participacao. */
export function participationMetric(participation, key) {
  const metrics = (participation && participation.metrics) || {}

  return Number(metrics[key] || 0)
}

/** Desconto ao comprador anunciado pela campanha. */
export function discountLabel(campaignData) {
  const c = campaignData || {}

  if (c.discount_amount === null || c.discount_amount === undefined) return ''

  return c.discount_type === 'VA'
    ? currencyFormatter(Number(c.discount_amount))
    : `${Number(c.discount_amount).toLocaleString('pt-BR', { maximumFractionDigits: 2 })}%`
}

/** Comissao anunciada por uma campanha ainda nao aderida. */
export function campaignCommissionLabel(campaignData) {
  const c = campaignData || {}

  if (c.commission_amount === null || c.commission_amount === undefined) return '—'

  return c.commission_type === 'VA'
    ? currencyFormatter(Number(c.commission_amount))
    : `${Number(c.commission_amount).toLocaleString('pt-BR', { maximumFractionDigits: 2 })}%`
}
